import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Map, List, fromJS } from 'immutable';

import { Message, Icon, Button } from 'semantic-ui-react';
import Tooltip from 'material-ui/Tooltip';
import { ModalTemplate, Loading, Button as Btn } from 'components';

import { CtLicenseEdit } from 'containers';

import classNames from 'classnames/bind';
import styles from './LicenseEditModal.css';
const cx = classNames.bind(styles);

class LicenseEditModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      editInvalid: false,
      editOnProgress: true,
      editSaveNow: false,
      disableSave: false
    };
  }

  setDisableSave = value => {
    const stateObj = {};
    if (this.state.disableSave !== value) {
      stateObj.disableSave = value;
    }
    if (!value && this.state.editSaveNow) {
      stateObj.editSaveNow = false;
    }
    this.setState(stateObj);
  };

  setEditInvalid = value => {
    if (this.state.editInvalid !== value) {
      const stateObj = {
        editInvalid: value
      };
      this.setState(stateObj);
    }
  };

  setEditOnProgress = value => {
    if (this.state.editOnProgress !== value) {
      this.setState({ editOnProgress: value });
    }
  };

  dispatchSave = () => {
    this.setState({
      editSaveNow: true
    });
  };

  cancleAction = () => {
    const { mountEditModal } = this.props;

    mountEditModal();
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { disableSave, editInvalid, editOnProgress, editSaveNow } = this.state;
    const { isAuth, licenseInfo, actionMode, mountEditModal } = this.props;
    const { setDisableSave, setEditInvalid, setEditOnProgress, dispatchSave, cancleAction } = this;

    let requestTitle = '';
    if (actionMode === 'add') {
      requestTitle = defineMessages(
        formatMessage({ id: 'LicenseEditModal_1', defaultMessage: '라이센스 추가 발급 신청' })
      );
      // } else if (actionMode === 'renew') {
      //   requestTitle += defineMessages(formatMessage({ id: 'LicenseEditModal_2', defaultMessage: '라이센스 갱신 신청' }));
    } else {
      requestTitle = defineMessages(formatMessage({ id: 'LicenseEditModal_3', defaultMessage: '라이센스 정보' }));
    }

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        closeOnDocumentClick={false}
        className={cx('modal-license-edit modal-admin tiny common-content')}
        closeIcon={<Icon name="close" link />}
        onToggleModal={mountEditModal}
        visible
        header={
          <div className={cx('modal-custom-header')}>
            <div>{requestTitle}</div>
          </div>
        }
        buttons={
          <div className={cx('inline-block')}>
            <Btn buttonColor="#bbbbbb" onClick={cancleAction}>
              {defineMessages(formatMessage({ id: 'LicenseEditModal_4', defaultMessage: '취 소' }))}
            </Btn>
            <Btn
              className={cx('brand-button')}
              loading={editOnProgress}
              disabled={disableSave && (editInvalid || editOnProgress)}
              onClick={dispatchSave}>
              {isAuth === 2
                ? defineMessages(formatMessage({ id: 'LicenseEditModal_5', defaultMessage: '저 장' }))
                : defineMessages(formatMessage({ id: 'LicenseEditModal_6', defaultMessage: '신 청' }))}
            </Btn>
          </div>
        }>
        <CtLicenseEdit
          actionMode={actionMode}
          licenseInfo={licenseInfo}
          editSaveNow={editSaveNow}
          setEditInvalid={setEditInvalid}
          setEditOnProgress={setEditOnProgress}
          setDisableSave={setDisableSave}
          handleOnToggleEditModal={mountEditModal}
        />
      </ModalTemplate>
    );
  }
}

export default injectIntl(LicenseEditModal);



// WEBPACK FOOTER //
// ./src/script/components/license/LicenseEditModal.js